/**
 * 거래처명 단축 표기.
 *   "광주.전남레미콘공업협동조합" → "관급(광주전남)"
 *   "{지역}공업협동조합"             → "관급({지역})"
 *
 * 그 외는 원본 그대로. 점/공백은 지역명에서 제거.
 */
export function displayCompany(company: string): string {
  if (!company) return "—";
  const m = company.match(/^(.+?)(?:레미콘)?공업협동조합/);
  if (m && m[1]) {
    const region = m[1].replace(/[.\s·-]/g, "");
    return `관급(${region})`;
  }
  return company;
}
